import { useEffect, useRef, type RefObject } from "react";

// Capture clicks so other controls keep their normal navigation and toggle behavior.
export function useWidgetDismiss(panel: RefObject<HTMLElement | null>, open: boolean, triggerSelector: string, onClose: () => void) {
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    if (!open) return;
    const dismiss = (event: MouseEvent) => {
      const target = event.target;
      if (target instanceof Element && !panel.current?.contains(target) && !target.closest(triggerSelector)) close.current();
    };
    document.addEventListener("click", dismiss, true);
    return () => document.removeEventListener("click", dismiss, true);
  }, [open, panel, triggerSelector]);
}
